export default __webpack_public_path__ + "static/media/hht2_ep05_timeline_q01_a.d25f55d9.png";